import styled from 'styled-components';

export const StyledHr = styled.hr`
  background: ${(p) => p.theme.alias.shadow};
  width: 100%;
  height: 2px;
  border: none;
  margin: ${(p) => p.theme.space[3]} 0;
`;
